import React from "react";
import {
   BarChart, Bar, Cell,
  ResponsiveContainer,
  CartesianGrid,
  XAxis,
  YAxis,
  Legend,
  Tooltip,
  Brush
} from "recharts";
import { numberFormat } from "../../../config/numberFormat";

// Example data for cash in hand by source/type


const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', 'red', 'pink'];

const WillGiveChart = ({data}) => {
  console.log(data);
  const totalCash = data.reduce((sum, item) => sum + item.value, 0);

  const getPath = (x, y, width, height) => {
    return `M${x},${y + height}C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3}
    ${x + width / 2}, ${y}
    C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${x + width}, ${y + height}
    Z`;
  };

    const TriangleBar = (props) => {
        const { fill, x, y, width, height } = props;

        return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />;
    };

  const formatCurrency = (val) =>
    `₹${val.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

  if (totalCash === 0) {
    return (
      <div style={styles.card}>
        <h3 style={styles.header}>You'll Give</h3>
        <p style={{ color: "#999", fontStyle: "italic" }}>No data available</p>
      </div>
    );
  }

  return (
    <div style={styles.card}>
      <h3 style={styles.header}>You'll Give - {formatCurrency(totalCash)}</h3>
      <div>
        <ResponsiveContainer width="100%" height={350} >
          <BarChart
              data={data}
              margin={{ top: 20, right: 10, left: 40, bottom: 20 }}
              barCategoryGap="20%"
              >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis tickFormatter={numberFormat} />
              <Bar dataKey="value" fill="#8884d8" shape={<TriangleBar />} label={{ position: 'top', formatter: (value) => numberFormat(value) }}>
                  {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
              </Bar>
              <Brush dataKey="name" height={30} stroke="#8884d8" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

const styles = {
  card: {
    padding: "20px",
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    fontFamily: "sans-serif"
  },
  header: {
    fontSize: "18px",
    marginBottom: "16px"
  },
};

export default WillGiveChart;